import { initReactI18next } from 'react-i18next';
import ro from '@locales/ro/translation.json';
import ru from '@locales/ru/translation.json';
import uk from '@locales/uk/translation.json';
import i18n from 'i18next';
import Backend from 'i18next-http-backend';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: 'ro',
    resources: {
      ru: { translation: ru },
      ro: { translation: ro },
      uk: { translation: uk },
    },
    returnObjects: true,
  });

export default i18n;
